import { BackgroundType } from '@rsa-digital/evo-shared-components/components/Background';
import MiniGuide from '@rsa-digital/evo-shared-components/components/MiniGuide';
import { graphql } from 'gatsby';
import React from 'react';
import {
  processImageAsset,
  processOptionalCta,
  unwrapSingleton,
} from 'helpers/csTypeProcessors';
import { CsAsset, CsCta, CsIcon } from 'types/contentStack';

type MiniGuideBlockProps = {
  mini_guide: {
    html_id?: string;
    styled_background?: boolean;
    background_type?: BackgroundType;
    title: string;
    subtitle?: string;
    sections: string[];
    primary_cta: [CsCta] | null;
    secondary_cta: [CsCta] | null;
    image: CsAsset | null;
    custom_bullet_icon: [CsIcon] | [];
  };
};

export const query = graphql`
  fragment MiniGuideBlock on cs__mini_guide {
    html_id
    styled_background
    background_type
    title
    subtitle
    sections
    primary_cta {
      ...Cta
    }
    secondary_cta {
      ...Cta
    }
    image {
      ...Asset
    }
    custom_bullet_icon {
      ...Icon
    }
  }
`;

const MiniGuideBlock: React.FC<MiniGuideBlockProps> = ({ mini_guide }) => (
  <MiniGuide
    id={mini_guide.html_id}
    data-cy="MiniGuide"
    styledBackground={mini_guide.styled_background}
    title={mini_guide.title}
    subtitle={mini_guide.subtitle}
    sections={mini_guide.sections}
    primaryCta={processOptionalCta(mini_guide.primary_cta, 'MiniGuidePrimaryCta')}
    secondaryCta={processOptionalCta(mini_guide.secondary_cta, 'MiniGuideSecondaryCta')}
    image={processImageAsset(mini_guide.image)}
    customBulletIcon={unwrapSingleton(mini_guide.custom_bullet_icon)?.icon_code}
    forceLargeImageOnTablet
    forceUseAllColumns
    backgroundType={mini_guide.background_type}
  />
);
export default React.memo(MiniGuideBlock);
